
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hero/category/[slug]",
      function () {
        return require("private-next-pages/hero/category/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hero/category/[slug]"])
      });
    }
  